import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface DeleteEvent {
	uriParams: Api.Operations['deleteEvent']['parameters']['path']
	params?: Api.Operations['deleteEvent']['parameters']['query']
	response: Api.Operations['deleteEvent']['responses']['200']['content']['application/json']
}

export const deleteEvent = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<DeleteEvent>(
		{
			method: 'delete',
			url: '/events/{eventId}',
			...overideConfig,
		},
		axiosInstance,
	)
